import { useState, useEffect } from 'react';

export const useCharacterCounter = (value: string, maxLength?: number) => {
  const [currentLength, setCurrentLength] = useState(0);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (value) {
      setCurrentLength(value.length);
      if (maxLength && value.length >= maxLength) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setCurrentLength(0);
      setIsError(false);
    }
  }, [value, maxLength]);

  return { currentLength, maxLength, isError };
};
